import { OrderTypes } from "../../../constants/OrderTypes";
import Transaction from "../../../entities/checkout/transaction/Transaction";
import { ITransactionWithBasketItems } from "../../../entities/checkout/transaction/types";
import { IManhattanFactory } from "../../manhattan/types";
import { TransactionDetailsOttFactory } from "./TransactionDetailsOttFactory";
import { TransactionDetailsFtthFactory } from "./TransactionDetailsFtthFactory";
import { TransactionDetailsOttPostpaidFactory } from "./TransactionDetailsOttPostpaidFactory";
import { TransactionDetailsTelcoFactory } from "./TransactionDetailsTelcoFactory";
import { TransactionDetailsAccessoryFactory } from "./TransactionDetailsAccessoryFactory";
import { TransactionDetailsComplexFactory } from "./TransactionDetailsComplexFactory";

export const TransactionFactory: IManhattanFactory = class TransactionFactory {

  static create(transaction: ITransactionWithBasketItems) {
    let transactionDetails = null;

    switch (transaction.flow) {
    case OrderTypes.BUNDLE_OTT:
      transactionDetails = TransactionDetailsOttFactory.create(
        transaction.details
      );
      break;
    case OrderTypes.BUNDLE_FTTH:
      transactionDetails = TransactionDetailsFtthFactory.create(
        transaction.details
      );
      break;
    case OrderTypes.TELCO:
    case OrderTypes.P2PDJ:
      transactionDetails = TransactionDetailsTelcoFactory.create(
        transaction.details
      );
      break;
    case OrderTypes.BUNDLE_POST_OTT:
      transactionDetails = TransactionDetailsOttPostpaidFactory.create(
        transaction.details
      );
      break;
    case OrderTypes.ACCESSORY:
      transactionDetails = TransactionDetailsAccessoryFactory.create(
        transaction.details
      );
      break;
    case OrderTypes.COMPLEX:
      transactionDetails = TransactionDetailsComplexFactory.create(
        transaction.details
      );
      break;
    }

    return new Transaction(
      transaction.flow,
      transactionDetails,
      transaction.basket,
      transaction.onlyPosition
    );
  }

};
